import {wymsFetch, getParams} from '@/utils/fetch';

// 应用管理列表
export function queryModuleList(args) {
    const params = getParams(true, args);
    params.append('isIntegrate', args.isIntegrate);
    params.append('moduleName', args.moduleName);
    params.append('schoolType', args.schoolType);
    params.append('systemType', args.systemType);

    return wymsFetch({
        url: 'module/queryModuleList',
        method: 'post',
        data: params
    });
}
// 应用管理列表
export function deleteModule(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'module/deleteModule',
        method: 'get',
        params
    });
}
// 查询使用分类
export function queryModuleTypeFromDict() {

    return wymsFetch({
        url: 'module/queryModuleTypeFromDict',
        method: 'get'
    });
}
// 新增应用
export function insertModule(args) {
    const params = getParams();
    params.append('code', args.code);
    params.append('domainName', args.domainName);
    params.append('ip', args.ip);
    params.append('isIntegrate', args.isIntegrate);
    params.append('logoUrl', args.logoUrl);
    params.append('moduleType', args.moduleType);
    params.append('name', args.name);
    params.append('profile', args.profile);
    params.append('schoolType', args.schoolType);
    params.append('sendSensitiveInfo', args.sendSensitiveInfo);
    params.append('statisticsCode', args.statisticsCode);
    params.append('systemType', args.systemType);

    return wymsFetch({
        url: 'module/insertModule',
        method: 'post',
        data: params
    });
}
// 编辑应用
export function updateModule(args) {
    const params = getParams();
    params.append('code', args.code || '');
    params.append('domainName', args.domainName || '');
    params.append('ip', args.ip || '');
    params.append('isIntegrate', args.isIntegrate || '');
    params.append('logoUrl', args.logoUrl || '');
    params.append('moduleType', args.moduleType || '');
    params.append('name', args.name || '');
    params.append('profile', args.profile || '');
    params.append('schoolType', args.schoolType || '');
    params.append('sendSensitiveInfo', args.sendSensitiveInfo || '');
    params.append('statisticsCode', args.statisticsCode || '');
    params.append('systemType', args.systemType || '');
    params.append('id', args.id);
    params.append('callbackUrl', args.callbackUrl || '');
    params.append('callbackUrlOnOff', args.callbackUrlOnOff || '');
    params.append('dataRange', args.dataRange || '');

    return wymsFetch({
        url: 'module/updateModule',
        method: 'post',
        data: params
    });
}
// 修改应用
export function updateModuleConfig(args) {
    const params = getParams();
    params.append('id', args.id);
    if(args.callbackUrl) {
        params.append('callbackUrl', args.callbackUrl);
    }
    if(args.callbackUrlOnOff) {
        params.append('callbackUrlOnOff', args.callbackUrlOnOff);
    }
    if(args.mobileUrl) {
        params.append('mobileUrl', args.mobileUrl);
    }
    if(args.dataRange) {
        params.append('dataRange', args.dataRange);
    }
    if(args.mobileUrlOnOff) {
        params.append('mobileUrlOnOff', args.mobileUrlOnOff);
    }
    if(args.pcUrl) {
        params.append('pcUrl', args.pcUrl);
    }
    if(args.pcUrlOnOff) {
        params.append('pcUrlOnOff', args.pcUrlOnOff);
    }
    if(args.type) {
        params.append('type', args.type);
    }

    return wymsFetch({
        url: 'module/update',
        method: 'GET',
        params
    });
}
// 编辑应用
export function queryModule(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'module/queryModule',
        method: 'post',
        data: params
    });
}

// 查询已安装该应用的学校
export function getUsedSchools(args) {
    const params = getParams();
    params.append('areaCode', args.areaCode);
    params.append('bussinessNumber', args.bussinessNumber);
    params.append('schoolname', args.schoolname);
    params.append('moduleId', args.moduleId);
    params.append('type', args.type);


    return wymsFetch({
        url: 'module/getUsedSchools',
        method: 'GET',
        params
    });
}

// 查询已安装该应用的学校
export function scanLoginIntro(args) {
    const params = getParams();
    params.append('id', args.id);

    return wymsFetch({
        url: 'module/scanLoginIntro',
        method: 'get',
        params
    });
}
// 获取postcode
export function queryPostcodeFromDict() {

    return wymsFetch({
        url: 'module/queryPostcodeFromDict',
        method: 'get'
    });
}

// 卸载学校应用
export function updateUninstallModule(args) {
    const params = getParams();
    params.append('moduleId', args.moduleId);
    params.append('schoolId', args.schoolId);

    return wymsFetch({
        url: 'schoolModule/updateUninstallModule',
        method: 'get',
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/moduleApp.js